import type { NextPage } from "next";
import React from "react";
import Slider, { Settings } from "react-slick";
import Image from "next/image";

import manBoard from "image/manBoard.jpg";
import manDesk from "image/man-desk.jpg";
import code from "image/code.jpg";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const ImageData = () => {
  const imageUrl: any = [];
  imageUrl.push(manBoard);
  {
    imageUrl &&
      imageUrl.map((item: any, i: any) => {
        console.log("item", item);

        return;
      });
  }
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  imageHover: {
    transition: "all .2s ease-in-out",
    "&:hover": {
      transition: "scale(1.1)",
    },
  },
}));

const About: NextPage = () => {
  const classes = useStyles();
  const settings = {
    autoplay: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
  };
  return (
    <>
      <div className={classes.root}>
        <Grid container>
          <Grid className={`slider-div ${classes.imageHover} `} item md={4}>
            <Image
              className={`carusal-image ${classes.imageHover} `}
              src={manBoard}
              height="300"
              width="500"
              alt="man board"
            />
          </Grid>
          <Grid className="slider-div" item md={4}>
            <Image
              className="carusal-image"
              src={manDesk}
              height="300"
              width="500"
              alt="desk"
            />
          </Grid>
          <Grid className="slider-div" item md={4}>
            <Image
              className="carusal-image"
              src={code}
              height="300"
              width="500"
              alt="code"
            />
          </Grid>
        </Grid>

        {/* <Slider {...settings}>
          <div className="slider-div">
            <Image
              className="carusal-image"
              src={manBoard}
              height="300"
              width="500"
              alt="man board"
            />
          </div>
          <div className="slider-div">
            <Image
              className="carusal-image"
              src={manDesk}
              height="300"
              width="500"
              alt="desk"
            />
          </div>
          <div className="slider-div">
            <Image
              className="carusal-image"
              src={code}
              height="300"
              width="500"
              alt="code"
            />
          </div>
        </Slider> */}
      </div>
    </>
  );
};

export default About;
